import $ from 'jquery';
import ProductsFilters from './ProductsFilters';
require('jquery-match-height/jquery.matchHeight.js');

var Products = {
    selectors: {
        products_sidebar_main_categories_nav: $('.products__sidebar-categories-nav'),
        products_main_category_items: $('.products__sidebar-categories-nav-item > a'),
        products_category_list_toggle: $('.products-category-list__toggle'),
        products_items: $('.product-item'),
        related_info_nav: $('.related-info-nav'),
        product_details_related_info_nav_item: $('.related-info-nav__list-item-link'),
        related_info_content: $('.related-info-content'),
        product_details_related_info_content_item: $('.related-info-content__item'),
        product_details_main_image: $('.product-details-item__image'),
        product_details_gallery_item: $('.product-details-item__gallery-item'),
        product_details_gallery_video_item: $('.product-details-item__gallery-item--video'),
        product_details_video_modal: $('#videoModal'),
        products_categories_mobile_nav_toggler: $('.nav-link--products-categories-toggler')
    },

    initDiscountsLoading: function() {
        let discountResults = [];
        let discountUrls = [];
        $('.discounts-list-label').each(function() {
            let promoLabel = $(this);
            let url = promoLabel.data('discount-url');
            let check = jQuery.inArray(url, discountUrls);
            if(check !== -1) {
                promoLabel.html(discountResults[check]);
                if (discountResults[check] != '') promoLabel.removeClass('d-none');
            } else {
                $.ajax({
                    type: "GET",
                    url: url,
                    async: false,
                    success: function (data) {
                        discountResults.push(data.html);
                        discountUrls.push(url);
                        promoLabel.html(data.html);
                        if (data.html != '') promoLabel.removeClass('d-none');
                    },
                    error: function (data) {
                    }
                });
            }
        });
    },
    init: function () {
        this.eventHandler();
        ProductsFilters.init();
    },

    initProductPartOfPromopackBadgeLoading: function() {
        $('.promopacks-check-item').each(function() {
            let url = $(this).data('promopack-check-url');
            let $self = $(this);
            $.ajax({
                type: "GET",
                url: url,
                async: false,
                success: function (data) {
                    if (data.isPartOfPromopack) {
                        $self.closest('.product-item').next().find('.product-item__promopack-part-label').html(data.html).removeClass('d-none');
                        $self.html(data.html);
                        $self.removeClass('d-none');
                    }
                },
                error: function (data) {
                    console.error(data);
                }
            });
        });
    },

    initProductPartOfMultilineBadgeLoading: function() {
        //console.log($('.multiline-check-item'), 1);
        $('.multiline-check-item').each(function() {
            let url = $(this).data('multiline-check-url');
            let $self = $(this);
            $.ajax({
                type: "GET",
                url: url,
                async: false,
                success: function (data) {
                    if (data.isPartOfMultiline) {
                        $self.closest('.product-item').next().find('.product-item__multiline-part-label').html(data.html).removeClass('d-none');
                        $self.html(data.html);
                        $self.removeClass('d-none');
                    }
                },
                error: function (data) {
                    console.error(data);
                }
            });
        });
    },

    getProductRelatedPromopacks: function() {
        $('.btn-promopacks-modal-trigger').click(function() {
            //console.log('getProductRelatedPromopacks called');
            let url = $(this).data('product-code-url');
            let $modal = $(`${$(this).data('target')}`);
            $.ajax({
                type: "GET",
                url: url,
                async: false,
                success: function (data) {
                    $modal.find('.modal-body').html(data.html);
                },
                error: function (data) {
                    console.error(data);
                }
            });

        })
    },

    initDetails: function () {
        $('body').on('keyup', '#quantity', delay(Products.updatePriceQtyBlock, 250));
        $('#add-to-cart input').on('keypress', function(e) {
            return e.which !== 13;
        });
        $('body').on('click, change', '#measure_unit_code', delay(Products.updatePriceQtyBlock, 0));
        this.loadMoreSimilarProducts();
        this.loadMoreRelatedProducts();
        this.productDetailsSendRequest();
    },

    eventHandler: function () {

    },

    validateProductQuantityInput: function () {
        $('.decimal').on('input', function () {
            var pattern = new RegExp(/^(\d+)?([.]?\d+)?$|^(\d+\.)$/, 'igm');
            var value = $(this).val();
            var oldValue = value.slice(0, -1);

            if (value.match(pattern) === null) {
                $(this).val(oldValue);
            };
        })
    },

    productsCategoriesHandler: function () {
        var selectors = this.selectors;
        var subcategoryListToggle = selectors.products_category_list_toggle;

        subcategoryListToggle.click(function(e) {
            e.preventDefault();
            if ($(e.target).is('.products-category-list__toggle-link')) {
                location.href = this.href;
            } else {
                $(e.target).parents('.products-category-list__item').toggleClass('products-category-list__item--toggled');
            }
        })
    },

    productDetailsGalleryHandler: function () {
        var selectors = this.selectors;

        //selectors.product_details_gallery_item.click(function () {
            /*if ($(this).is(selectors.product_details_gallery_video_item)) {
                // TODO: handle click on video item
                let videoSource = $(this).data('video');
                selectors.product_details_video_modal.find('.modal-body').html(
                    `<iframe src="${videoSource}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
                );
            } else {*/
                // if($(window).width() > 991) {
                //     let imageUrl = $(this).data('image');
                //     if ($(this).hasClass('product-details-item__gallery-item--video')) {
                //         selectors.product_details_main_image.addClass('show-play-icon');
                //     } else {
                //         selectors.product_details_main_image.removeClass('show-play-icon');
                //     }
                //     selectors.product_details_main_image.find('img').attr('src', imageUrl);
                //     selectors.product_details_gallery_item.not($(this)).removeClass('product-details-item__gallery-item--selected');
                //     $(this).addClass('product-details-item__gallery-item--selected');
                // }
            //}
        //})
    },

    productDetailsRelatedInfoNavigationHandler: function () {
        var selectors = this.selectors;
        var relatedInfoContentOffsetTop = selectors.related_info_content.offset().top;
        var headerContainerHeight = $('header').height();
        var relatedInfoNavHeight = selectors.related_info_nav.height();
        var navFixedPoint = relatedInfoContentOffsetTop - headerContainerHeight;
        var triggerOffset = 10;

        selectors.product_details_related_info_nav_item.click(function () {
            if($(window).width() > 991) {
                var selectedItem = $(`#${$(this).data('toggle')}`);
                var top = selectedItem.offset().top - (headerContainerHeight + (relatedInfoNavHeight - triggerOffset));
                var timeout = 0;
                if (!selectors.related_info_nav.hasClass('related-info-nav--fixed')) {
                    $('html, body').animate({ scrollTop: navFixedPoint }, 300);
                    if ($(this).is(selectors.product_details_related_info_nav_item[0])) {
                        top = selectedItem.offset().top - (headerContainerHeight + relatedInfoNavHeight - 5);
                    } else {
                        top = selectedItem.offset().top - (headerContainerHeight + (relatedInfoNavHeight * 2 - triggerOffset));
                    }

                    timeout = 250;
                } else {
                    if ($(this).is(selectors.product_details_related_info_nav_item[0])) {
                        top = selectedItem.offset().top - (headerContainerHeight - 5);
                    } else {
                        if ($(selectors.product_details_related_info_content_item[0]).hasClass('has-nav-fixed')) {
                            top = selectedItem.offset().top - (headerContainerHeight + (relatedInfoNavHeight * 2 - triggerOffset));
                        }
                    }
                }
                 setTimeout(function () {
                    $('html, body').animate({ scrollTop: top }, 'slow');
                }, timeout);
            }
        });

        $(window).on('scroll', function () {
            if ($(window).width() > 991) {
                if ($(window).scrollTop() >= navFixedPoint) {
                    selectors.related_info_nav.addClass('related-info-nav--fixed');
                } else {
                    selectors.related_info_nav.removeClass('related-info-nav--fixed');
                    selectors.product_details_related_info_nav_item.removeClass('related-info-nav__list-item-link--active');
                }


                if ($(window).scrollTop() >= navFixedPoint && $(window).scrollTop() < (navFixedPoint + relatedInfoNavHeight)) {
                    $(selectors.product_details_related_info_content_item[0]).addClass('has-nav-fixed');
                } else {
                    $(selectors.product_details_related_info_content_item[0]).removeClass('has-nav-fixed');
                }

                selectors.product_details_related_info_content_item.each(function(){
                    var currentOffsetStart = $(this).offset().top - (headerContainerHeight + relatedInfoNavHeight);
                    var currentOffsetEnd = currentOffsetStart + $(this).height();
                    var $currentItem = $(`a[data-toggle="${$(this).attr('id')}"]`);
                    if ($(window).scrollTop() >= currentOffsetStart && $(window).scrollTop() < currentOffsetEnd) {
                        selectors.product_details_related_info_nav_item.removeClass('related-info-nav__list-item-link--active');
                        $currentItem.addClass('related-info-nav__list-item-link--active');
                    }
                });
            }
        });

        $(window).resize(function() {
            if ($(window).width() < 992) {
                selectors.product_details_related_info_content_item.removeClass('related-info-content__item--fixed');
            }
        })
    },

    productsCategoriesMobileNavigationHandler: function () {
        var selectors = this.selectors;

        selectors.products_categories_mobile_nav_toggler.click(function () {
            $(`#${$(this).data('toggle')}`).toggleClass('products-categories-mobile-nav--open');
            $('body').toggleClass('modal-open');
        })
    },

    productsEqualTitlesHandler: function() {
        $('.product-item__title--equal').matchHeight();
    },

    updatePriceQtyBlock: function() {
        var form = $('#add-to-cart');
        var url = form.data('qty-calculation-url');

        $.ajax({
            type: "POST",
            url: url,
            data: form.serialize(),
            success: function(data)
            {
                $('div.price-and-quantity-info-block').html(data.html);
                //$('.product-details-item__promo-label > span').html(data.discount);
                $('#discount').html(data.discount);
                $('#final-price').html(data.finalPrice);
                $('#regular-price').html(data.regularPrice);
            },
            error: function(data)
            {

            }
        });
    },

    updatePriceQty: function() {
        var form = $(this).closest('form');
        var url = form.data('qty-calculation-url');

        $.ajax({
            type: "POST",
            url: url,
            data: form.serialize(),
            success: function(data)
            {
                form.parent().parent().find('.discount-holder').html(data.discount);
                //form.parent().parent().find('.product-item__promo-label > span').html(data.discount);
                form.parent().parent().find('.final-price-holder').html(data.finalPrice);
                form.parent().parent().find('.regular-price-holder').html(data.regularPrice);
                form.parent().parent().find('.catalog_price').html(data.regularPrice_no_sup);
                form.parent().parent().find('.discount').html(data.discount);
                form.parent().parent().find('.final_price').html(data.finalPrice_no_sup);
            },
            error: function(data)
            {

            }
        });
    },

    productDetailsSendRequest: function() {
        $('body').on('submit', 'form#send-product-request', function(e) {
            e.preventDefault();
            $.ajax({
                type: 'POST',
                data: $(this).serialize(),
                url: $(this).attr('action'),
                beforeSend: function() {

                },
                error: function(resp) {
                    $('div.ajax-messages').html(resp.responseJSON.message);
                },
                success: function(resp) {
                    $('div.ajax-messages').html(resp.message)
                    $('form#send-product-request')[0].reset();
                }
            });
        });
    },

    seriesProductsDataExpandHandler: function () {
        $('.product-data-toggle').click(function () {
            if ($(this).hasClass('product-data-toggle--expanded')) {
                $(this).removeClass('product-data-toggle--expanded');
                $(`#${$(this).data('toggle')}`).addClass('d-none');
            } else {
                $(this).addClass('product-data-toggle--expanded');
                $(`#${$(this).data('toggle')}`).removeClass('d-none');
            }
        });
    },

    loadMoreSimilarProducts: function() {
        $('body').on('click', 'a.load-more-similar-products', function(e) {
            e.preventDefault();
            var url = $(this).attr('href');
            $.ajax({
                type: "GET",
                url: url,
                success: function(data)
                {
                    $('div.similar-products-container').append(data.html);
                    if (data.url == '') {
                        $('a.load-more-similar-products').remove();
                    } else {
                        $('a.load-more-similar-products').attr('href', data.url);
                    }
                },
                error: function(data)
                {
                    $('a.load-more-similar-products').remove();
                }
            });
        });
    },

    loadMoreRelatedProducts: function() {
        $('body').on('click', 'a.load-more-related-products', function(e) {
            e.preventDefault();
            var url = $(this).attr('href');
            $.ajax({
                type: "GET",
                url: url,
                success: function(data)
                {
                    $('div.related-products-container').append(data.html);
                    if (data.url == '') {
                        $('a.load-more-related-products').remove();
                    } else {
                        $('a.load-more-related-products').attr('href', data.url);
                    }
                },
                error: function(data)
                {
                    $('a.load-more-related-products').remove();
                }
            });
        });
    },

    mobileCompareMove: function() {

        if(window.innerWidth < 992) {
            if($('#mobile-start-column').length > 0) {
                var position = $('#mobile-start-column').position().left;
                $('#mobile-start-column').parents('.table-responsive').scrollLeft(position);
            }
        }

    }
}

export default Products;
